// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CookiesBanner_section__d8baK {
  position: fixed;
  bottom: 8vh;
  left: 0;
  width: 100%;
  padding: 0 1vw;
  box-sizing: border-box;
  border-radius: 15px;
  background-color: #dbdbdb;
  color: var(--font-primary-color);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  z-index: 1000;
}

.CookiesBanner_no_footer__saUOU {
  bottom: 1vh;
}

.CookiesBanner_paragraph__Fakas {
  margin-top: 0;
  margin-bottom: 1vh;
}

.CookiesBanner_button_section__nHPNI {
  padding-bottom: 1vh;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 1.5vw;
  flex-wrap: wrap;
}`, "",{"version":3,"sources":["webpack://./src/_features/cookiesBanner/views/CookiesBanner/CookiesBanner.module.scss","webpack://./src/_common/scss/_colors.scss"],"names":[],"mappings":"AAEA;EACE,eAAA;EACA,WAAA;EACA,OAAA;EACA,WAAA;EACA,cAAA;EACA,sBAAA;EACA,mBAAA;EACA,yBCHS;EDIT,gCCRa;EDSb,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,aAAA;AADF;;AAIA;EACE,WAAA;AADF;;AAIA;EACE,aAAA;EACA,kBAAA;AADF;;AAIA;EACE,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,UAAA;EACA,eAAA;AADF","sourcesContent":["@import '@common/scss/_colors';\n\n.section {\n  position: fixed;\n  bottom: 8vh;\n  left: 0;\n  width: 100%;\n  padding: 0 1vw;\n  box-sizing: border-box;\n  border-radius: 15px;\n  background-color: $grey-200;\n  color: $font-primary;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-wrap: wrap;\n  z-index: 1000;\n}\n\n.no_footer {\n  bottom: 1vh;\n}\n\n.paragraph {\n  margin-top: 0;\n  margin-bottom: 1vh;\n}\n\n.button_section {\n  padding-bottom: 1vh;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 1.5vw;\n  flex-wrap: wrap;\n}\n","$primary: var(--primary-color);\n$secondary: var(--secondary-color);\n$accent: var(--accent-color);\n$font-primary: var(--font-primary-color);\n$font-secondary: var(--font-secondary-color);\n$font-accent: var(--font-accent-color);\n$grey-100: #f4f5f7;\n$grey-200: #dbdbdb;\n$grey-300: #acacac;\n$grey-400: #838383;\n$chart-dataset-1: #df6767;\n$chart-dataset-2: #efa12c;\n$warning: orange;\n$error: #df6767;\n$white: #fff;\n$transparent: transparent;\n\n$primary-font-color: #fff;\n$secondary-font-color: #fff;\n$accent-font-color: #fff;\n$warning-font-color: #fff;\n$error-font-color: #fff;\n$filter-bg: #fff;\n\n$bg-main: var(--background-color);\n$card-bg: #fff;\n$default-control-bg: #fff;\n$card-shadow: 3px 3px 3px -1px rgba(0, 0, 0, 0.1);\n$default-shadow-color: rgba(0, 0, 0, 0.1);\n\n$default-border-color: #acacac;\n$default-backdrop-color: rgba(0, 0, 0, 0.8);\n\n$default-navbar-color: #fff;\n\n$stats-card-bg-color: #fff;\n$stats-card-color: #000;\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"section": `CookiesBanner_section__d8baK`,
	"no_footer": `CookiesBanner_no_footer__saUOU`,
	"paragraph": `CookiesBanner_paragraph__Fakas`,
	"button_section": `CookiesBanner_button_section__nHPNI`
};
export default ___CSS_LOADER_EXPORT___;
